module.exports = __webpack_public_path__ + "static/media/64700-full.e67a5f29.png";